import React from "react";
import backgroundMobileArtwork from "../../assets/artworks/Incarnatie.png";
import { useTranslation } from "react-i18next";
import { parseParagraphs } from "../../utils/parseParagraphs";
import {
    Root,
    Content,
    Slide,
    Title,
    Name,
    StatementParagraph,
    ContentWrapper,
} from "./Intro.styles";

function Intro() {
    const { t } = useTranslation("intro");

    const renderContent = () => {
        return (
            <Slide>
                <ContentWrapper>
                    <Name>{t("name")}</Name>
                    <Title>{t("job_title")}</Title>
                    {parseParagraphs(t("statement")).map((paragraph) => (
                        <StatementParagraph>{paragraph}</StatementParagraph>
                    ))}
                </ContentWrapper>
            </Slide>
        );
    };

    return (
        <Root backgroundImage={backgroundMobileArtwork}>
            <Content>{renderContent()}</Content>
        </Root>
    );
}

export default Intro;
